export interface CatalogImportJobProgress {
  phase: string;
  label: string;
  completed: number;
  total: number;
  percent: number;
}

export interface CatalogImportJobResult {
  categoriesImported: number;
  productsImported: number;
  venuesImported: number;
  warehousesCreated: number;
  machinesImported: number;
  slotsImported: number;
  errors: string[];
  productsPulledForSlots?: string[];
}

export interface CatalogImportJobDto {
  jobId: string;
  organizationId: string;
  status: 'queued' | 'running' | 'completed' | 'failed';
  dryRun: boolean;
  progress: CatalogImportJobProgress;
  result: CatalogImportJobResult | null;
  error: string | null;
  startedAt: string;
  updatedAt: string;
  finishedAt: string | null;
}

export const CATALOG_IMPORT_JOB_STORAGE_KEY = 'bright.express.catalogImportJobId';
